<template>
  <div>
    <select :value="selectionType" name="selectionType" class="form-control" @change="handleChange">
      <option value="current">This event block</option>
      <option value="other">Another event block</option>
    </select>
    <select v-if="selectionType === 'other'" :value="eventBlockId" name="eventBlockId" class="form-control" @change="handleChange">
      <option value="">Select event block</option>
      <option
        v-for="block in allBlocks"
        :value="block.id"
      >
        {{ block.name }}
      </option>
    </select>
    <div v-if="Object.keys(errors).length > 0" class="alert alert-danger">
      <p v-for="error in errors" class="errors mb-0">
        {{ error }}
      </p>
    </div>
    <div v-if="showText">
      {{ selectedEventBlock }} will be completed early. Open events in this block will be marked as skipped, and future events will be deleted. Logic will not be applied to them.
    </div>
    <div>
      <label><input :checked="deleteBlock" type="checkbox" name="deleteBlock" class="mr-1 mt-1" @change="handleChange">Also archive this block</label>
    </div>
  </div>
</template>
<script>
  import BaseComponent from '@/EventLogic/components/BaseComponent.vue';
  import {enumValidator} from "@/EventLogic/util";

  export default {
    extends: BaseComponent,
    props: {
      id: String,
      selectionType: {
        type: String,
        default: "current",
        validator: enumValidator(['current', 'other'])
      },
      eventBlockId: {
        type: [String, Number],
        default: ""
      },
      deleteBlock: {
        type: Boolean,
        default: false
      },
    },
    computed: {
      selectedEventBlock() {
        if (this.selectionType === "current") {
          return "This current Event Block"
        } else {
          const block = this.allBlocks[this.eventBlockId];
          return block ? `Any open "${block.name}" Event Blocks` : '***DELETED EVENT BLOCK***';
        }
      },
      showText() {
        return !(this.selectionType === "other" && !this.eventBlockId);
      },
      allBlocks() {
        const sourceBlocks = this.config.eventBlocksByType.Source ?? {};
        const dateBlocks = this.config.eventBlocksByType.Date ?? {};
        const variableBlocks = this.config.eventBlocksByType.Variable ?? {};
        return Object.assign({}, sourceBlocks, dateBlocks, variableBlocks);
      }
    },
    methods: {
      validate: function() {
        this.errors = {};

        if (this.selectionType === "other" && !this.eventBlockId) {
          this.errors.eventBlockId = 'Please select a block to close';
        }

        return Object.keys(this.errors).length === 0;
      }
    }
  };
</script>
